export default __webpack_public_path__ + "static/media/icon_collapsed.345bdaff.svg";